var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetcher, getCSRFToken } from '../utils/api';
export const fetchEmployeeAccountLinks = () => __awaiter(void 0, void 0, void 0, function* () { return (yield fetcher('/api/inside/v1/employee_account_links')).data; });
export const createEmployeeAccountLink = (companyPublicUid, email) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield fetcher('/api/inside/v1/employee_account_links', {
        method: 'POST',
        body: JSON.stringify({ employee_account_link: { company_id: companyPublicUid, email } }),
    })).data;
});
export const approveEmployeeAccountLink = (id) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield fetcher(`/api/inside/v1/employee_account_links/${id}/approve`, {
        method: 'POST',
    })).data;
});
export const deleteEmployeeAccountLink = (id) => __awaiter(void 0, void 0, void 0, function* () {
    yield fetcher(`/api/inside/v1/employee_account_links/${id}`, { method: 'DELETE' });
});
export const fetchAccountSwitchOptions = () => __awaiter(void 0, void 0, void 0, function* () { return (yield fetcher('/api/inside/v1/account_switch_challenges/options')).data; });
export const fetchCurrentAccountSwitchChallenge = () => __awaiter(void 0, void 0, void 0, function* () { return (yield fetcher('/api/inside/v1/account_switch_challenges/current')).data; });
export const cancelAccountSwitchChallenge = () => __awaiter(void 0, void 0, void 0, function* () {
    yield fetcher('/api/inside/v1/account_switch_challenges/current', { method: 'DELETE' });
});
export const startAccountSwitchChallenge = (targetPublicUid, companyPublicUid) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield fetcher('/api/inside/v1/account_switch_challenges', {
        method: 'POST',
        body: JSON.stringify({ target_public_uid: targetPublicUid, company_public_uid: companyPublicUid }),
    });
    if (!['github', 'twitter', 'facebook'].includes(data.provider) || data.authorization_path !== `/users/auth/${data.provider}`) {
        throw new Error('再認証先が正しくありません。');
    }
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = data.authorization_path;
    const token = document.createElement('input');
    token.type = 'hidden';
    token.name = 'authenticity_token';
    token.value = getCSRFToken() || '';
    form.appendChild(token);
    document.body.appendChild(form);
    form.submit();
});
export const accountSwitchDestination = (companyPublicUid) => companyPublicUid ? `/companies/management/${encodeURIComponent(companyPublicUid)}` : '/';
export const switchAccount = (targetPublicUid, credentials) => __awaiter(void 0, void 0, void 0, function* () {
    yield fetcher('/api/inside/v1/account_switch', {
        method: 'POST',
        body: JSON.stringify(Object.assign({ target_public_uid: targetPublicUid }, credentials)),
    });
});
